import { Component, ViewChild, TemplateRef, EventEmitter, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ProcessoResumo } from '@app/models/processo.model';
import { FinanceiroProcessoService } from '@app/services/financeiro-processo.service';
import { ParticipanteAnotacao } from '@app/models/participante-anotacao.model';
import { ComunicacaoComponentesService } from '@app/services/comunicacao-componentes.service';
import { log } from 'console';
@Component({
  selector: 'app-financeiro-processo',
  templateUrl: './financeiro-processo.component.html'
})
export class FinanceiroProcessoComponent{
  @ViewChild('modalInformacoesCliente', {static: true}) modalInformacoesCliente: TemplateRef<any>;

  acessoNovosLancamentos: boolean;
  processoResumo: ProcessoResumo = new ProcessoResumo();

  participanteAnotacao = new ParticipanteAnotacao();

  bsModalRef: BsModalRef;

  resumoPreenchido: boolean = false;
  permissoesPreenchido: boolean = false;

  constructor(
    private router: Router,
    @Inject(ToastrService) public toastr: ToastrService,
    private modalService: BsModalService,
    private financeiroProcessoService: FinanceiroProcessoService,
    private comunicacaoComponentesService: ComunicacaoComponentesService
  ) {
    this.processoResumo = new ProcessoResumo();
    this.router.events.subscribe(() => window.scrollTo(0, 0));
  }

  

  enviaEventoBusca(valorTab: number) {
    this.comunicacaoComponentesService.enviaClick(valorTab);
  }

  fecharModal() {
    this.bsModalRef.hide();
  }
  
  abrirModalInformacoesProcesso() {
    this.financeiroProcessoService
    .obterAnotacoesProcesso(this.processoResumo.Id)
    .subscribe(data => {
      if(data != null){
        this.participanteAnotacao = data;
      }
      else{
        this.participanteAnotacao.ProcessoId = this.processoResumo.Id;
      }
        this.bsModalRef = this.modalService.show(this.modalInformacoesCliente);
    });
  }

  salvarAnotacoesCliente() {
    this.financeiroProcessoService.salvarAnotacoesProcesso(this.participanteAnotacao).subscribe(
      () => {
        if(this.participanteAnotacao.Anotacao)
          this.processoResumo.PossuiAnotacaoFinanceira = true;
        else
          this.processoResumo.PossuiAnotacaoFinanceira = false;

        this.fecharModal();
        this.toastr.success("Anotação realizada com sucesso!");
      },
      error => {
        this.toastr.error(error.error.errors[0]);
      }
    );
  }
}
